$(document).on('turbolinks:load', function(){
  $("#sprov a.add_fields").
    data("association-insertion-position", 'before').
    data("association-insertion-node", 'this');

  $('#sprov').bind('cocoon:after-insert',
     function() {
       $("#sprov_from_list").hide();
       $("#sprov a.add_fields").hide();
     });
  $('#sprov').bind("cocoon:after-remove",
     function() {
       $("#sprov_from_list").show();
       $("#sprov a.add_fields").show();
     });
});


$(document).on('turbolinks:load', function(){
  function check_to_hide_or_show_add_link() {
    if ($('#sprov .nested-fields:visible').length == 1) {
       $('#sprov .links a').hide();
     } else {
       $('#sprov .links a').show();
     }
   }

   $('#sprov').on('cocoon:after-insert', function() {
     check_to_hide_or_show_add_link();
   });

   $('#sprov').on('cocoon:after-remove', function() {
     check_to_hide_or_show_add_link();
   });
   check_to_hide_or_show_add_link();
});

$(document).on('turbolinks:load', function(){
  $("#sperson a.add_fields").
    data("association-insertion-position", 'before').
    data("association-insertion-node", 'this');

  $('#sperson').bind('cocoon:after-insert',
     function() {
       $("#sperson_from_list").hide();
       $("#sperson a.add_fields").hide();
     });
  $('#sperson').bind("cocoon:after-remove",
     function() {
       $("#sperson_from_list").show();
       $("#sperson a.add_fields").show();
     });
});


$(document).on('turbolinks:load', function(){
  function check_to_hide_or_show_add_link() {
    if ($('#sperson .nested-fields:visible').length == 1) {
       $('#sperson .links a').hide();
     } else {
       $('#sperson .links a').show();
     }
   }

   $('#sperson').on('cocoon:after-insert', function() {
     check_to_hide_or_show_add_link();
   });

   $('#sperson').on('cocoon:after-remove', function() {
     check_to_hide_or_show_add_link();
   });
   check_to_hide_or_show_add_link();
});
